import { HIGHLIGHT_TYPES } from 'modules/codeless-events/consts/iframeParentConstants';
import { useElementHighlighter } from './useElementHighlighter';

const buttonSelector = 'button, a, [role="button"], input[type="button"], input[type="submit"]';

export const useButtonHighlighter = ({ isHighlighting, onButtonClick }) => {
    return useElementHighlighter({
        selector: buttonSelector,
        onElementClick: onButtonClick,
        highlightType: HIGHLIGHT_TYPES.POTENTIAL_ELEMENTS,
        isHighlighting,
    });
};
